import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import FullScreenGallery from '@uikit/components/FullScreenGalleryProps/FullScreenGallery';
import clsx from 'clsx';
import { useState } from 'react';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import styles from './HeroGallery.module.scss';
import { ReactComponent as IconPhoto } from './photo-icon.svg';
import type { HeroGalleryProps } from './types';

const HeroGallery = ({ images }: HeroGalleryProps) => {
  const [firstImage, secondImage, thirdImage] = images.slice(0, 3);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={clsx(styles.base, {
        [styles.oneItem]: !secondImage,
        [styles.twoItems]: !thirdImage && secondImage,
      })}
    >
      <div className={styles.largeItem}>
        <LegacyPicture
          asset={firstImage}
          breakpointAspectRatioConfigs={[
            { breakpoint: BreakPoint.XSS, width: 344 },
            { breakpoint: BreakPoint.XS, width: 544 },
            { breakpoint: BreakPoint.SM, width: 735 },
            { breakpoint: BreakPoint.MD, width: 638 },
            { breakpoint: BreakPoint.LG, width: 776 },
            { breakpoint: BreakPoint.XL, width: 936 },
          ]}
          fitCover
        />
      </div>
      {secondImage && (
        <div className={styles.smallItem}>
          <LegacyPicture
            asset={secondImage}
            breakpointAspectRatioConfigs={[
              { breakpoint: BreakPoint.MD, width: 315 },
              { breakpoint: BreakPoint.LG, width: 384 },
              { breakpoint: BreakPoint.XL, width: 464 },
            ]}
            fitCover
          />
        </div>
      )}
      {thirdImage && (
        <div className={styles.smallItem}>
          <LegacyPicture
            asset={thirdImage}
            breakpointAspectRatioConfigs={[
              { breakpoint: BreakPoint.MD, width: 315 },
              { breakpoint: BreakPoint.LG, width: 384 },
              { breakpoint: BreakPoint.XL, width: 464 },
            ]}
            fitCover
          />
        </div>
      )}

      {images.length > 1 && (
        <button
          className={styles.button}
          type="button"
          aria-label="Alle Fotos anzeigen"
          onClick={() => setIsOpen(true)}
        >
          <IconPhoto />{' '}
          <span className={styles.desktopButtonLabel}>Alle Fotos anzeigen</span>
          <span className={styles.mobileButtonLabel}>1 / {images.length}</span>
        </button>
      )}

      <FullScreenGallery
        images={images}
        handleOpen={() => setIsOpen((isOpen) => !isOpen)}
        isOpen={isOpen}
      />
    </div>
  );
};

export default HeroGallery;
